module.exports = __webpack_public_path__ + "static/forgot-password-ce9d0d136da3ab27b93129ab037d8d1b.png";